/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Library_Sort_DescriptionInputs */

const en_settings_v2_library_sort_description = /** @type {(inputs: Settings_V2_Library_Sort_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How your files are sorted in the library and folders`)
};

const es_settings_v2_library_sort_description = /** @type {(inputs: Settings_V2_Library_Sort_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo se ordenan tus archivos en la biblioteca y las carpetas`)
};

/**
* | output |
* | --- |
* | "How your files are sorted in the library and folders" |
*
* @param {Settings_V2_Library_Sort_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_library_sort_description = /** @type {((inputs?: Settings_V2_Library_Sort_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Library_Sort_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_library_sort_description(inputs)
	return en_settings_v2_library_sort_description(inputs)
});